var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spider-scrapy" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "setting-param-dialog",
          attrs: {
            title: _vm.$t("Parameter Edit"),
            visible: _vm.dialogVisible,
            width: "600px",
            "before-close": _vm.onCloseDialog
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "action-wrapper",
              staticStyle: { "margin-bottom": "10px", "text-align": "right" }
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-plus"
                  },
                  on: { click: _vm.onSettingsActiveParamAdd }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Add")) + " ")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.activeParamData } },
            [
              _vm.activeParam.type === "object"
                ? _c("el-table-column", {
                    attrs: { label: _vm.$t("Key") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: { size: "small" },
                                model: {
                                  value: scope.row.key,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "key", $$v)
                                  },
                                  expression: "scope.row.key"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3703476878
                    )
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Value") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.activeParam.type === "object"
                          ? _c("el-input", {
                              attrs: { size: "small", type: "number" },
                              on: {
                                change: function() {
                                  return (scope.row.value = Number(
                                    scope.row.value
                                  ))
                                }
                              },
                              model: {
                                value: scope.row.value,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "value", $$v)
                                },
                                expression: "scope.row.value"
                              }
                            })
                          : _vm.activeParam.type === "array"
                          ? _c("el-input", {
                              attrs: { size: "small" },
                              model: {
                                value: scope.row.value,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "value", $$v)
                                },
                                expression: "scope.row.value"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Action"),
                  width: "60px",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSettingsActiveParamRemove(
                                scope.$index
                              )
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "plain", size: "small" },
                  on: { click: _vm.onCloseDialog }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onSettingsConfirm }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Add Scrapy Spider"),
            visible: _vm.isAddSpiderVisible,
            width: "480px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isAddSpiderVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "add-spider-form",
              attrs: {
                model: _vm.addSpiderForm,
                "label-width": "80px",
                "inline-message": ""
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("Name"), prop: "name", required: "" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Name") },
                    model: {
                      value: _vm.addSpiderForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addSpiderForm, "name", $$v)
                      },
                      expression: "addSpiderForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Domain"),
                    prop: "domain",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Domain") },
                    model: {
                      value: _vm.addSpiderForm.domain,
                      callback: function($$v) {
                        _vm.$set(_vm.addSpiderForm, "domain", $$v)
                      },
                      expression: "addSpiderForm.domain"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Template"),
                    prop: "template",
                    required: ""
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("Template") },
                      model: {
                        value: _vm.addSpiderForm.template,
                        callback: function($$v) {
                          _vm.$set(_vm.addSpiderForm, "template", $$v)
                        },
                        expression: "addSpiderForm.template"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "basic", label: "basic" }
                      }),
                      _c("el-option", {
                        attrs: { value: "crawl", label: "crawl" }
                      }),
                      _c("el-option", {
                        attrs: { value: "csvfeed", label: "csvfeed" }
                      }),
                      _c("el-option", {
                        attrs: { value: "xmlfeed", label: "xmlfeed" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "plain", size: "small" },
                  on: {
                    click: function($event) {
                      _vm.isAddSpiderVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: _vm.isAddSpiderLoading ? "el-icon-loading" : "",
                    disabled: _vm.isAddSpiderLoading
                  },
                  on: { click: _vm.onAddSpiderConfirm }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Settings"), name: "settings" } },
            [
              _c("div", { staticClass: "settings" }, [
                !_vm.spiderScrapySettings || !_vm.spiderScrapySettings.length
                  ? _c(
                      "div",
                      { staticClass: "settings" },
                      [
                        _c("span", { staticClass: "empty-text" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("No data available")) + " "
                          )
                        ]),
                        _vm.spiderScrapyErrors.settings
                          ? [
                              _c("label", { staticClass: "errors-label" }, [
                                _vm._v(_vm._s(_vm.$t("Errors")) + ":")
                              ]),
                              _c("el-alert", {
                                attrs: { type: "error" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getScrapyErrors("settings")
                                  )
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _c(
                      "div",
                      { staticClass: "settings" },
                      [
                        _c(
                          "div",
                          { staticClass: "top-action-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  icon: "el-icon-plus"
                                },
                                on: { click: _vm.onSettingsAdd }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Add Variable")) + " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "success",
                                  icon: "el-icon-check"
                                },
                                on: { click: _vm.onSettingsSave }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.spiderScrapySettings,
                              border: "",
                              "header-cell-style": {
                                background: "rgb(48, 65, 86)",
                                color: "white"
                              },
                              "max-height": "calc(100vh - 240px)"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Variable Name"),
                                width: "240px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-autocomplete", {
                                        attrs: {
                                          size: "small",
                                          "suffix-icon": "el-icon-edit",
                                          "fetch-suggestions":
                                            _vm.settingsKeysFetchSuggestions
                                        },
                                        model: {
                                          value: scope.row.key,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "key", $$v)
                                          },
                                          expression: "scope.row.key"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Variable Type"),
                                width: "120px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { size: "small" },
                                          on: {
                                            change: function($event) {
                                              return _vm.onSettingsParamTypeChange(
                                                scope.row
                                              )
                                            }
                                          },
                                          model: {
                                            value: scope.row.type,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "type", $$v)
                                            },
                                            expression: "scope.row.type"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              value: "string",
                                              label: _vm.$t("String")
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: "number",
                                              label: _vm.$t("Number")
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: "boolean",
                                              label: _vm.$t("Boolean")
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: "array",
                                              label: _vm.$t("Array/List")
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              value: "object",
                                              label: _vm.$t("Object/Dict")
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Variable Value"),
                                width: "calc(100% - 150px)"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      scope.row.type === "string"
                                        ? _c("el-input", {
                                            attrs: {
                                              size: "small",
                                              "suffix-icon": "el-icon-edit"
                                            },
                                            model: {
                                              value: scope.row.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.value"
                                            }
                                          })
                                        : scope.row.type === "number"
                                        ? _c("el-input", {
                                            attrs: {
                                              type: "number",
                                              size: "small",
                                              "suffix-icon": "el-icon-edit"
                                            },
                                            on: {
                                              change: function($event) {
                                                scope.row.value = Number(
                                                  scope.row.value
                                                )
                                              }
                                            },
                                            model: {
                                              value: scope.row.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.value"
                                            }
                                          })
                                        : scope.row.type === "boolean"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px"
                                              }
                                            },
                                            [
                                              _c("el-switch", {
                                                attrs: {
                                                  size: "small",
                                                  "active-color": "#67C23A"
                                                },
                                                model: {
                                                  value: scope.row.value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.value"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                                "font-size": "12px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    JSON.stringify(
                                                      scope.row.value
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("el-button", {
                                                staticStyle: {
                                                  "margin-left": "10px"
                                                },
                                                attrs: {
                                                  type: "warning",
                                                  size: "mini",
                                                  icon: "el-icon-edit"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onSettingsEditParam(
                                                      scope.row,
                                                      scope.$index
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                    ]
                                  }
                                }
                              ])
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("Action"),
                                width: "60px",
                                align: "center"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                          circle: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onSettingsRemove(
                                              scope.$index
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
              ])
            ]
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Spiders"), name: "spiders" } },
            [
              _c("div", { staticClass: "spiders" }, [
                !_vm.spiderForm.spider_names ||
                !_vm.spiderForm.spider_names.length
                  ? _c(
                      "div",
                      { staticClass: "spiders" },
                      [
                        _c("span", { staticClass: "empty-text error" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "No data available. Please check whether your spiders are missing dependencies or no spiders created."
                                )
                              ) +
                              " "
                          )
                        ]),
                        _vm.spiderScrapyErrors.spiders
                          ? [
                              _c("label", { staticClass: "errors-label" }, [
                                _vm._v(_vm._s(_vm.$t("Errors")) + ":")
                              ]),
                              _c("el-alert", {
                                attrs: { type: "error" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.getScrapyErrors("spiders")
                                  )
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _c("div", { staticClass: "spiders" }, [
                      _c(
                        "div",
                        { staticClass: "action-wrapper" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus"
                              },
                              on: { click: _vm.onAddSpider }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Add Spider")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "ul",
                        { staticClass: "list" },
                        _vm._l(_vm.spiderForm.spider_names, function(s) {
                          return _c(
                            "li",
                            {
                              key: s,
                              staticClass: "item",
                              on: {
                                click: function($event) {
                                  return _vm.onClickSpider(s)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "el-icon-star-on" }),
                              _vm._v(" " + _vm._s(s) + " "),
                              _vm.loadingDict[s]
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ])
              ])
            ]
          ),
          _c("el-tab-pane", { attrs: { label: "Items", name: "items" } }, [
            _c("div", { staticClass: "items" }, [
              !_vm.spiderScrapyItems || !_vm.spiderScrapyItems.length
                ? _c(
                    "div",
                    { staticClass: "items" },
                    [
                      _c("span", { staticClass: "empty-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                      ]),
                      _vm.spiderScrapyErrors.items
                        ? [
                            _c("label", { staticClass: "errors-label" }, [
                              _vm._v(_vm._s(_vm.$t("Errors")) + ":")
                            ]),
                            _c("el-alert", {
                              attrs: { type: "error" },
                              domProps: {
                                innerHTML: _vm._s(_vm.getScrapyErrors("items"))
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "items" },
                    [
                      _c(
                        "div",
                        { staticClass: "action-wrapper" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus"
                              },
                              on: { click: _vm.onAddItem }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Add Item")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                type: "success",
                                icon: "el-icon-check"
                              },
                              on: { click: _vm.onItemsSave }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          )
                        ],
                        1
                      ),
                      _c("el-tree", {
                        attrs: {
                          data: _vm.spiderScrapyItems,
                          "default-expand-all": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var node = ref.node
                              var data = ref.data
                              return _c(
                                "span",
                                {
                                  staticClass: "custom-tree-node",
                                  class: "level-" + data.level
                                },
                                [
                                  data.level === 1
                                    ? [
                                        !node.isEdit
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "label",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onItemLabelEdit(
                                                      node,
                                                      data,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-star-on"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(data.label) + " "
                                                ),
                                                _c("i", {
                                                  staticClass: "el-icon-edit"
                                                })
                                              ]
                                            )
                                          : _c("el-input", {
                                              ref: "el-input-" + data.id,
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "Item Name"
                                                ),
                                                size: "mini"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.onItemChange(
                                                    node,
                                                    data,
                                                    $event
                                                  )
                                                },
                                                blur: function($event) {
                                                  return _vm.$set(
                                                    node,
                                                    "isEdit",
                                                    false
                                                  )
                                                }
                                              },
                                              model: {
                                                value: data.name,
                                                callback: function($$v) {
                                                  _vm.$set(data, "name", $$v)
                                                },
                                                expression: "data.name"
                                              }
                                            }),
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini",
                                                  icon: "el-icon-plus"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onAddItemField(
                                                      data,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("Add Field")
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                  icon: "el-icon-delete"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeItem(
                                                      data,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Remove")) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  data.level === 2
                                    ? [
                                        !node.isEdit
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "label",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onItemLabelEdit(
                                                      node,
                                                      data,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-right"
                                                }),
                                                _vm._v(
                                                  " " + _vm._s(node.label) + " "
                                                ),
                                                _c("i", {
                                                  staticClass: "el-icon-edit"
                                                })
                                              ]
                                            )
                                          : _c("el-input", {
                                              ref: "el-input-" + data.id,
                                              attrs: {
                                                placeholder: _vm.$t(
                                                  "Field Name"
                                                ),
                                                size: "mini"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.onItemFieldChange(
                                                    node,
                                                    data,
                                                    $event
                                                  )
                                                },
                                                blur: function($event) {
                                                  node.isEdit = false
                                                }
                                              },
                                              model: {
                                                value: data.name,
                                                callback: function($$v) {
                                                  _vm.$set(data, "name", $$v)
                                                },
                                                expression: "data.name"
                                              }
                                            }),
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                  icon: "el-icon-delete"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onRemoveItemField(
                                                      node,
                                                      data,
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.$t("Remove")) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
            ])
          ]),
          _c(
            "el-tab-pane",
            { attrs: { label: "Pipelines", name: "pipelines" } },
            [
              !_vm.spiderScrapyPipelines || !_vm.spiderScrapyPipelines.length
                ? _c(
                    "div",
                    { staticClass: "pipelines" },
                    [
                      _c("span", { staticClass: "empty-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                      ]),
                      _vm.spiderScrapyErrors.pipelines
                        ? [
                            _c("label", { staticClass: "errors-label" }, [
                              _vm._v(_vm._s(_vm.$t("Errors")) + ":")
                            ]),
                            _c("el-alert", {
                              attrs: { type: "error" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getScrapyErrors("pipelines")
                                )
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _c("div", { staticClass: "pipelines" }, [
                _c(
                  "ul",
                  { staticClass: "list" },
                  _vm._l(_vm.spiderScrapyPipelines, function(s) {
                    return _c(
                      "li",
                      {
                        key: s,
                        staticClass: "item",
                        on: {
                          click: function($event) {
                            return _vm.$emit("click-pipeline")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "el-icon-star-on" }),
                        _vm._v(" " + _vm._s(s) + " ")
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }